import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useHomepageList = () => {
    const [homepages, setHomepages] = useState([])
    const [loadingPagestate, setLoadingPage] = useState(false)

    const getHomepageList = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get("/auth/announcements")
            if (res.status === 200) {
                setHomepages(res.data.data)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteAnnouncement = async (id) => {
        try {
            let res = await axiosInstance.delete(`/auth/announcements/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Announcement")
                // Refresh the list without full page reload
                await getHomepageList()
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        homepages,
        getHomepageList,
        loadingPagestate,
        deleteAnnouncement,
    }
}

export default useHomepageList